import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GlobalVars } from '../../providers/global-vars';
import { ApiCaller } from '../../providers/api-caller';
import {TranslateService} from 'ng2-translate/ng2-translate';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { TechniciansPage } from '../../pages/technicians/technicians';

/*
  Generated class for the Partners page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-partners',
  templateUrl: 'partners.html'
})
export class PartnersPage {

    public login: any = {};
    public invalidCounter: any = 0;
    public waitingTime: any = 0;
    public timedOut:any = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiCaller : ApiCaller, 
              public globalVars : GlobalVars, private translate: TranslateService,
             private idle: Idle, private keepalive: Keepalive) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad PartnersPage');
      this.globalVars.loadSettings(false).then((success) =>{
                   console.log('After loadSettings MyGatesPage '+JSON.stringify(this.globalVars.userSettings));
       });
  }
    eventHandler(keyCode) {
        if (keyCode == 13)
            this.doLogin();
    }

   startTimer(){
        this.idle.setIdle(1);
        this.idle.setTimeout(8*this.invalidCounter);
  //      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onTimeoutWarning.subscribe((countdown:number) => {
          console.log('TimeoutWarning: ' + countdown);
            this.waitingTime = countdown;
        });

        this.idle.onTimeout.subscribe(() => {
          console.log('Timeout');
            this.timedOut = true;
          this.doLogout();
        });
        this.idle.watch();
    }

    doLogout(){
    //    this.login.code = '';
        this.globalVars.generalVars = null;
        this.globalVars.devices = null;
        this.idle.stop();
        this.waitingTime = 0;
        this.globalVars.clearSettings();
        /*
        this._headerService.exit()
            .subscribe(
                data => {
                    
                },
                    error => console.log(error)
            ) 
            */
    }


   doLogin(){
        if (!this.login.email || this.login.email.length <= 0 || !this.login.password || this.login.password.length <= 0){
            this.globalVars.showAlert('Missing info','Please enter your email/password');
            return;
        }

        console.log("Processing login code: "+this.login.code);
        var requestApp = {};
        (requestApp as any).requestType = 'validatePartnerLogin';

        (requestApp as any).request = {};
        (requestApp as any).request.email = this.login.email;
        (requestApp as any).request.password = this.login.password;

        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, this.invalidCounter < 2).then(data => {
            if (data && (data as any).result == 200){
                
                if (!this.globalVars.generalVars)
                    this.globalVars.generalVars = {};
                this.globalVars.generalVars.partnerUserId = (data as any).partnerUserId;
                this.globalVars.generalVars.partnerId = (data as any).partnerId;
                this.globalVars.generalVars.partnerName = (data as any).partnerName;
                this.globalVars.saveSettings();
           //     this.startTimer();
            }else{
                this.invalidCounter++;
                if (this.invalidCounter > 2){
                    this.globalVars.showAlert('Problem?','Rememeber that your password is case sensitive.');
                    this.waitingTime = 5*this.invalidCounter;
                    this.startTimer();
                }
            }
        }); 
    }

    doTechnicians(){
        this.navCtrl.push(TechniciansPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/partners/partners.ts